import { type ComponentPropsWithoutRef } from "react";

import { cn } from "@/lib/utils";

export interface MarqueeProps extends ComponentPropsWithoutRef<"div"> {
  reverse?: boolean;
  pauseOnHover?: boolean;
  vertical?: boolean;
}

/**
 * Faixa em scroll infinito (duas cópias do conteúdo + translate -50%).
 * Use [--duration:20s] e opcionalmente [--gap:1rem] na className do pai.
 */
export function Marquee({
  className,
  reverse = false,
  pauseOnHover = false,
  vertical = false,
  children,
  ...props
}: MarqueeProps) {
  return (
    <div
      {...props}
      className={cn("group flex overflow-hidden p-2 [--duration:40s] [--gap:1rem]", className)}
    >
      <div
        className={cn(
          "flex shrink-0 [gap:var(--gap)]",
          vertical
            ? "h-max flex-col animate-marquee-vertical"
            : "w-max flex-row animate-marquee",
          pauseOnHover && "group-hover:[animation-play-state:paused]",
          reverse && "[animation-direction:reverse]",
        )}
      >
        <div
          className={cn("flex shrink-0 [gap:var(--gap)]", vertical ? "flex-col" : "flex-row")}
        >
          {children}
        </div>
        <div
          className={cn("flex shrink-0 [gap:var(--gap)]", vertical ? "flex-col" : "flex-row")}
          aria-hidden
        >
          {children}
        </div>
      </div>
    </div>
  );
}
